exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message{opacity:0}.message.show{opacity:1;transition:opacity 1s ease}", ""]);

// exports
